"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isGlobalLaunchUrl = isGlobalLaunchUrl;
/** Diagnostic scope only: never use this client-supplied context to choose routing or access. */
function isGlobalLaunchUrl(value) {
    if (typeof value !== 'string')
        return false;
    try {
        const url = new URL(value);
        return ['http:', 'https:'].includes(url.protocol) && url.hostname.endsWith('.global');
    }
    catch {
        return false;
    }
}
